[
    {
        "label": "Class A motorhome",
        "type": "Class_A_motorhome",
        "image": "enq_Class_A_rrnw09"
    },
    {
        "label": "Class B campervan",
        "type": "Class_B_campervan",
        "image": "enq_Class_B_j24cqy"
    },
    {
        "label": "Campervan",
        "type": "Campervan",
        "image": "enq_Class_B_j24cqy"
    },
    {
        "label": "Class C motorhome",
        "type": "Class_C_motorhome",
        "image": "enq_Class_C_npxvsa"
    },
    {
        "label": "Motorhome",
        "type": "Motorhome",
        "image": "enq_Class_C_npxvsa"
    },
    {
        "label": "Overlander",
        "type": "Overlander",
        "image": "enq_Overlander_lbgbll"
    },
    {
        "label": "Truck camper",
        "type": "Truck_camper",
        "image": "enq_Truck_i4i1xm"
    },
    {
        "label": "Bus or skoolie",
        "type": "Bus_or_skoolie",
        "image": "enq_Class_A_copy_o9ufmd"
    },
    {
        "label": "Trailer or 5th wheel",
        "type": "Trailer_or_5th_wheel",
        "image": "enq_5th_wheel_vaazmi"
    },
    {
        "label": "Mobile business",
        "type": "Mobile_business",
        "image": "enq_Commercial_qf6yv0"
    }
]